var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumbs.length > 0)?_c('div',_vm._l((_vm.breadcrumbs),function(breadcrumb,index){return _c('object-breadcrumbs-button',{key:index,attrs:{"model-class":breadcrumb.modelClass,"id":breadcrumb.id}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }